// extracted by mini-css-extract-plugin
export default {"container":"line-chart_container__wyVZT","axis-label":"line-chart_axis-label__yHlxX","axis":"line-chart_axis__vWxIj"};